import { callStatues, callStatuses, filterGenders, genders, Statuses } from "../modals/jobFormData";
import Select from "react-select";
import {
  useFunctionalityCompanyNames,
  useFunctionalityLanguage,
  useFunctionalityLanguageListNames,
  useFunctionalityOperatorNamesByCallCenterId,
  useFunctionalitySkill,
  useFunctionalitySkillListNames,
} from "../../pages/hooks";
import { useAppSelector, VRIAppStateType} from "../../core";
import { shallowEqual } from "react-redux";
import { AppConstants } from "../../configs/appConstants";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import {
  ApiSchemaColumn,
  ApiSchemaFilter,
  ApiSchemaFormFilter,
} from "../../models/api/filter";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";
import moment from "moment";
import { useFunctionalityResellerNames } from "../../pages/hooks/functionalityReseller";
import { OptionMapper } from "../../utils";

const brombergOption = { value: AppConstants.BrombergResellerId, label: 'Bromberg' };
const anyOption = { value: '', label: 'Any' };

type Props = {
  setFilterData: any;
  setLoaderProgress: any;
  setFilterDataChange?: any;
  pageName?: 'jobsPage' | 'callLogPage';
  callLogVariant?: 'default' | 'vendor' | 'internal' | 'overflow';
  setPageIndex: Function;
  disableTopMargin?: boolean;
  hideOperatorFilter?: boolean;
  hideResellerFilter?: boolean;
};

export function CommonFilter(props: Props): JSX.Element {
  const { setFilterData, setFilterDataChange, pageName, callLogVariant, setPageIndex, disableTopMargin } = props;
  const { onCompanyNames } = useFunctionalityCompanyNames();
  const { onResellerNames } = useFunctionalityResellerNames();
  const { onLanguageListName } = useFunctionalityLanguageListNames();
  const { onSkillListName } = useFunctionalitySkillListNames();
  const { onOperatorNamesByCallCenterId } = useFunctionalityOperatorNamesByCallCenterId();
  const [companyNames, setCompanyNames] = useState<any>();
  const [languageNameList, setLanguageNameList] = useState<any>([]);
  const [resellerNames, setResellerNames] = useState<any[]>([]);
  const [operatorNames, setOperatorNames] = useState<any[]>([]);
  const [skillListNames, setSkillListName] = useState<any>();
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();
  
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
  } = useForm<ApiSchemaFormFilter>();

  const userRole = useAppSelector(
    (state: VRIAppStateType) => state.auth.profile?.userRole,
    shallowEqual
  );

  const companyId = useAppSelector(
    (state: VRIAppStateType) => state.auth.profile?.companyId,
    shallowEqual
  );
  const callCenterId = useAppSelector(
    (state: VRIAppStateType) => state.auth.menuSettings?.callCenterSettings.callCenterId,
    shallowEqual
  );

  const isVendorCallLog = pageName === 'callLogPage' && callLogVariant === 'vendor';
  const canFilterByOperator = pageName === 'callLogPage' &&
    !props.hideOperatorFilter &&
    !isVendorCallLog &&
    (userRole === AppConstants.UserRoles.Admin ||
      userRole === AppConstants.UserRoles.ResellerAdmin);
  const canFilterByReseller = pageName === 'callLogPage' && !props.hideResellerFilter && !isVendorCallLog &&
    (userRole === AppConstants.UserRoles.Admin || userRole === AppConstants.UserRoles.Finance || userRole === AppConstants.UserRoles.Manager);
  const dependentCompanies = callLogVariant === 'internal' && canFilterByReseller;
  const includeBrombergOption = dependentCompanies || (callLogVariant === 'overflow' && canFilterByReseller);
  const resellerAndCompanyFirst = dependentCompanies || (callLogVariant === 'overflow' && canFilterByReseller);
  const [companyParentId, setCompanyParentId] = useState(anyOption.value);
  const [companiesLoading, setCompaniesLoading] = useState(dependentCompanies);
  const [companyLoadError, setCompanyLoadError] = useState(false);
  const [companyRetry, setCompanyRetry] = useState(0);
  const languageFilterFieldName = (isVendorCallLog
    ? 'LanguageName'
    : 'LanguageId') as keyof ApiSchemaFormFilter;
  React.useEffect(() => {
    if (!dependentCompanies && ((userRole === AppConstants.UserRoles.Admin ||
      userRole === AppConstants.UserRoles.Manager ||
      userRole === AppConstants.UserRoles.ResellerAdmin ||
      userRole === AppConstants.UserRoles.ResellerManager) || !(userRole === AppConstants.UserRoles.Operator || userRole === AppConstants.UserRoles.CompanyAdmin
        || userRole === AppConstants.UserRoles.CompanyFinance || userRole === AppConstants.UserRoles.User))) {
      onCompanyNames(callLogVariant === 'overflow' ? "" : companyId ?? "").then((res) => {
        setCompanyNames([
          {
            value: "",
            label: "Any",
          },
          ...res.data,
        ]);
      });
    }
    if (canFilterByReseller) {
      onResellerNames()
        .then((res) => {
          setResellerNames([
            anyOption,
            ...(includeBrombergOption ? [brombergOption] : []),
            ...res.data.filter((option: { value: string }) => !includeBrombergOption || option.value !== brombergOption.value)])
        })
    }
    if (pageName === 'jobsPage') {
      onSkillListName()
        .then((res) => {
          setSkillListName([
            {
              value: "",
              label: 'Any'
            },
            ...OptionMapper.mapperFunc(res.data)])
        })
    }
    if (userRole !== AppConstants.UserRoles.Operator) {
      onLanguageListName()
        .then((res) => {
          setLanguageNameList([
            {
              value: "",
              label: 'Any'
            },
            ...OptionMapper.mapperFunc(res.data)])
        })
    }
    if (canFilterByOperator && callCenterId) {
      onOperatorNamesByCallCenterId(callCenterId).then((res) => {
        setOperatorNames([
          {
            value: "",
            label: "Any",
          },
          ...res.data,
        ]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  React.useEffect(() => {
    if (!dependentCompanies) return;
    let active = true;
    setCompaniesLoading(true);
    setCompanyLoadError(false);
    setCompanyNames([]);
    onCompanyNames(companyParentId)
      .then((res) => {
        if (active) setCompanyNames([anyOption, ...res.data]);
      })
      .catch(() => {
        if (active) setCompanyLoadError(true);
      })
      .finally(() => {
        if (active) setCompaniesLoading(false);
      });
    return () => { active = false; };
  }, [dependentCompanies, companyParentId, companyRetry, onCompanyNames]);

  React.useEffect(() => {
    if (dependentCompanies) setValue('ResellerId', anyOption.value);
  }, [dependentCompanies, setValue]);

  const onFilterHandler = (data: ApiSchemaFormFilter) => {
    let columns: ApiSchemaColumn[] = [];
    let start, end;

    if (data) {
      for (let [key, value] of Object.entries(data)) {
        if (value === "" || value === undefined) continue;
        if (key === "startDate") {
          if (value) {
            start = moment(value).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else {
            start = "";
          }
        } else if (key === "endDate") {
          if (value) {
            end = moment(value).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else {
            end = "";
          }
        } else {
          let column: ApiSchemaColumn = { columnName: key, value: value };
          columns.push(column);
        }
      }
      if (start || end) {
        let dateColumn: ApiSchemaColumn = {
          columnName: pageName === 'jobsPage' ? "Start" : "CreatedAt",
          dateQuery: { startDate: start, endDate: end },
        };
        columns.push(dateColumn);
      }
    }

    ReactDOM.unstable_batchedUpdates(() => {
      setPageIndex(1);
      setFilterData((prevState: ApiSchemaFilter) => {
        return {
          ...prevState,
          filterQueries: columns,
        };
      });
      setFilterDataChange &&
        setFilterDataChange(Math.floor(Math.random() * 100) + 1);
    });
  };
  const [selectedLanguage, setSelectedLanguage] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedStatus, setSelectedStatus] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedCallStatus, setSelectedCallStatus] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedCompany, setSelectedCompany] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedGender, setSelectedGender] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedSkill, setSelectedSkill] = useState<any>([{ value: "", label: "Any" }]);
  const [selectedResellerNames, setSelectedResellerNames] = useState<any>([anyOption]);
  const [selectedOperator, setSelectedOperator] = useState<any>([{ value: "", label: "Any" }]);

  const vendorCallStatusOptions = [
    { label: "Any", value: "" },
    { label: "Propio", value: "propio" },
    { label: "Boostlingo", value: "boostlingo" },
  ];
  const callStatusOptions = isVendorCallLog ? vendorCallStatusOptions : callStatues;

  let dateLabel;
  switch (pageName) {
    case 'callLogPage':
      dateLabel = <label>Call Date</label>
      break;
    case 'jobsPage':
      dateLabel = <label>Booking Date</label>
      break;
    default:
      break;
  }

  let languageFormComponent = (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
      <label htmlFor="">Language</label>
      <input className="d-none" {...register(languageFilterFieldName, {})} />
      <Select
        options={languageNameList}
        value={selectedLanguage}
        components={{
          IndicatorSeparator: () => null,
        }}
        placeholder="Select a language"
        onChange={(value) => {
          const nextValue = isVendorCallLog ? value?.label ?? "" : value?.value;
          setValue(languageFilterFieldName, nextValue as any, {
            shouldValidate: true,
          });
          setSelectedLanguage([
            { label: value?.label, value: value?.value },
          ]);
        }}
      />
    </div>
  )

  let companyFormComponent = (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
      <label htmlFor="">Company</label>
      <input className="d-none" {...register('CompanyId', {})} />
      <Select
        isLoading={dependentCompanies && companiesLoading}
        isDisabled={dependentCompanies && (companiesLoading || companyLoadError)}
        options={companyNames}
        value={selectedCompany}
        components={{
          IndicatorSeparator: () => null,
        }}
        placeholder="Select a company"
        onChange={(value) => {
          setValue("CompanyId", value?.value, {
            shouldValidate: true,
          });
          setSelectedCompany([
            { label: value?.label, value: value?.value },
          ]);
        }}
      />
    </div>
  )
  const resellerFormComponent = (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
      <label htmlFor="">Reseller Name</label>
      <input className="d-none" {...register('ResellerId', {})} />
      <Select
        options={includeBrombergOption && resellerNames.length === 0 ? [anyOption, brombergOption] : resellerNames}
        value={selectedResellerNames}
        components={{
          IndicatorSeparator: () => null,
        }}
        placeholder="Select a reseller"
        onChange={(value) => {
          if (dependentCompanies && value?.value !== companyParentId) {
            setValue('CompanyId', '');
            setSelectedCompany([anyOption]);
            setCompanyNames([]);
            setCompaniesLoading(true);
            setCompanyParentId(value?.value ?? anyOption.value);
          }
          setValue("ResellerId", value?.value, {
            shouldValidate: true,
          });
          setSelectedResellerNames([
            { label: value?.label, value: value?.value },
          ]);
        }}
      />
    </div>
  );
  let operatorFormComponent = (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
      <label htmlFor="">Operator</label>
      <input className="d-none" {...register('CalleeId', {})} />
      <Select
        options={operatorNames}
        value={selectedOperator}
        components={{
          IndicatorSeparator: () => null,
        }}
        placeholder="Select an operator"
        onChange={(value) => {
          setValue("CalleeId", value?.value, {
            shouldValidate: true,
          });
          setSelectedOperator([
            { label: value?.label, value: value?.value },
          ]);
        }}
      />
    </div>
  )
  return (
    // <form onSubmit={handleSubmit(onSubmitStep1)} className="col-12 collapse mt-3" id="jobFilterPanel" >
    <div
      className={`col-12 collapse ${disableTopMargin ? "" : "mt-3"}`}
      id="commonFilterPanel"
    >
      <div className="card card-body border-radius-xl">
        <form onSubmit={handleSubmit(onFilterHandler)}>
          {dateLabel}
          <div className="row">
            <label htmlFor="bookingDate"></label>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 form-group">
              <Controller
                name="startDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Start date"
                    className="form-control"
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(value) => {
                      setStartDate(value!);
                      field.onChange(value)
                    }}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    maxDate={endDate}
                  />
                )}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 form-group">
              <Controller
                name="endDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    dateFormat="MM/dd/yyyy"
                    placeholderText="End date"
                    className="form-control"
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(value)=> {
                      field.onChange(value);
                      setEndDate(value ? value : undefined);
                    }}
                    minDate={startDate}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                  />
                )}
              />
            </div>
          </div>
          <div className="row">
            {resellerAndCompanyFirst && (
              <>
                {resellerFormComponent}
                {companyFormComponent}
                {companyLoadError && (
                  <div className="col-12 text-danger" role="alert">
                    Could not load companies. <button type="button" className="btn btn-link" onClick={() => setCompanyRetry((value) => value + 1)}>Retry</button>
                  </div>
                )}
              </>
            )}
            {(pageName === 'callLogPage' && userRole !== AppConstants.UserRoles.Operator) ?
              languageFormComponent :
              (pageName === 'jobsPage') ? languageFormComponent : null
            }
            {pageName === 'jobsPage' ?
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
                <label htmlFor="">Status</label>
                <input className="d-none" {...register('Status', {})} />
                <Select
                  options={Statuses}
                  value={selectedStatus}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Select a status"
                  onChange={(value) => {
                    setValue("Status", value?.value, {
                      shouldValidate: true,
                    });
                    setSelectedStatus([
                      { label: value?.label, value: value?.value },
                    ]);
                  }}
                />
              </div>
              :
              (pageName === 'callLogPage' && !(userRole === AppConstants.UserRoles.Operator || userRole === AppConstants.UserRoles.CompanyAdmin
                || userRole === AppConstants.UserRoles.CompanyFinance || userRole === AppConstants.UserRoles.User)) ?
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
                  <label htmlFor="">{isVendorCallLog ? "Vendor" : "Call Status"}</label>
                  <input className="d-none" {...register('CallStatus', {})} />
                  <Select
                    options={callStatusOptions}
                    value={selectedCallStatus}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    placeholder={isVendorCallLog ? "Select a vendor" : "Select a call status"}
                    onChange={(value) => {
                      setValue("CallStatus", value?.value, {
                        shouldValidate: true,
                      });
                      setSelectedCallStatus([
                        { label: value?.label, value: value?.value },
                      ]);
                    }}
                  />
                </div>
                : null
            }
            {pageName === 'jobsPage' ?
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
                <label htmlFor="">Skill</label>
                <input className="d-none" {...register('SkillId', {})} />
                <Select
                  options={skillListNames}
                  value={selectedSkill}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Select a skill"
                  onChange={(value) => {
                    setValue("SkillId", value?.value, {
                      shouldValidate: true,
                    });
                    setSelectedSkill([
                      { label: value?.label, value: value?.value },
                    ]);
                  }}
                />
              </div>
              :
              canFilterByReseller && !resellerAndCompanyFirst ?
                resellerFormComponent
                : null
            }
            {pageName === 'jobsPage' &&
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 form-group">
                <label htmlFor="">Gender</label>
                <input className="d-none" {...register('Gender', {})} />
                <Select
                  options={filterGenders}
                  value={selectedGender}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Select a gender"
                  onChange={(value) => {
                    setValue("Gender", value?.value, {
                      shouldValidate: true,
                    });
                    setSelectedGender([
                      { label: value?.label, value: value?.value },
                    ]);
                  }}
                />
              </div>
            }
            {(pageName === 'jobsPage' && (userRole === AppConstants.UserRoles.Admin ||
              userRole === AppConstants.UserRoles.Manager ||
              userRole === AppConstants.UserRoles.ResellerAdmin ||
              userRole === AppConstants.UserRoles.ResellerManager)) ?
              companyFormComponent :
              (pageName === 'callLogPage' && !resellerAndCompanyFirst && !(userRole === AppConstants.UserRoles.Operator || userRole === AppConstants.UserRoles.CompanyAdmin
                || userRole === AppConstants.UserRoles.CompanyFinance || userRole === AppConstants.UserRoles.User)) ?
                companyFormComponent : null
            }
            {canFilterByOperator ? operatorFormComponent : null}
          </div>
          <div className="row">
            <div className="col-12 text-right">
              <button
                type="button"
                className="btn btn-link text-uppercase filter-reset-btn"
                onClick={() => {
                  // setFilterData({ filterQueries: [] });
                  setFilterData((prevState: ApiSchemaFilter) => {
                    return {
                      ...prevState,
                      filterQueries: []
                    }
                  });
                  setFilterDataChange && setFilterDataChange(Math.floor(Math.random() * 100) + 1);
                  // reset();
                  setValue('startDate', undefined)
                  setValue('endDate', undefined)
                  setValue('CompanyId', "")
                  setValue('CalleeId', "")
                  setValue('ResellerId', '')
                  setValue("LanguageId", "")
                  setValue("LanguageName", "")
                  setValue("SkillId", "")
                  setValue("Gender", "")
                  setValue("CallStatus", "")
                  setValue("Status", "")
                  setSelectedCompany([]);
                  setSelectedGender([]);
                  setSelectedLanguage([]);
                  setSelectedSkill([]);
                  setSelectedStatus([]);
                  setSelectedCallStatus([]);
                  setSelectedResellerNames(dependentCompanies ? [anyOption] : []);
                  if (dependentCompanies) {
                    setCompanyParentId(anyOption.value);
                    setSelectedCompany([anyOption]);
                    setCompanyRetry((value) => value + 1);
                  }
                  setSelectedOperator([]);
                  setStartDate(undefined);
                  setEndDate(undefined);
                }}
              >
                Reset
              </button>
              <button
                type="submit"
                className="btn btn-primary text-uppercase mx-3"
              >
                Filter
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
